export default {
  props: {
    texto: {
      type: String,
      default: "",
    },
    titulo: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    oDataParent: {  // toda toda la informacion de la fila para hacer cosas
      type: Object,
      default: () => {}
    },
    sCampo: {
      type: String,
      default: "",
    },
    sTabla: {
      type: String,
      default: "",
    },
    sIdTable: {                // nombre del pimary key de la tabla para ver los detalles - Si son mas de una se deben separar por comas "," siempre se debe poner el nombre real del campo
      type: String,
      default: ''
    },
    sTipo: {                // tipo de campo que se esta cargando
      type: String,
      default: ''
    },
    oPermisos : {
      type: Object,
      default: () => { return {
          priv_access : '0',
          priv_insert : '0',
          priv_delete : '0',
          priv_update : '0'
        }
      }
    }
  },
  data() {
    return {
      valor: this.texto,
      esError: false,
    };
  },
  computed: {
    cmpPermisos() {
      return (this.oPermisos.priv_insert == '1' || this.oPermisos.priv_update == '1')
    }
  },
  watch: {
    valor (newValor, oldValor) {
      if(newValor !== oldValor ) this.$emit('onCeldaCambio', this.sTipo, newValor)
    }
  }
}